import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import styled from 'styled-components';
import { useTeamColors } from 'hooks';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
`;

export const SecondaryLoader = ({ size = 60 }) => {
  const { altColor } = useTeamColors();

  return (
    <LoaderContainer>
      <TailSpin color={altColor} height={size} width={size} />
    </LoaderContainer>
  );
};
